module.exports = __webpack_public_path__ + "static/media/health-icon.a66414b8.png";